/**
The main entry point for Exercise Dress Hero Page.

Referenced by page.exercise-dress.liquid templates.
* */
import React from 'react';
import ReactDOM from 'react-dom';
import DressesCampaign from './apps/pages/dresses-campaign/DressesCampaign';
/* eslint-disable max-len */

import { jsx as _jsx } from "react/jsx-runtime";

var init = function init() {
  ReactDOM.render( /*#__PURE__*/_jsx(DressesCampaign, {}), document.getElementById('page-dresses-campaign'));
};

init();